/* eslint-disable lines-between-class-members */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Customer } from "../Customers";
import { reviewTypes, reviewTypesTitle } from "./enums";
import { Product } from "./Product";
import { ProductReviewAttachment } from "./ProductReviewAttachment";
/**
 * Product review class
 */

export class ProductReview extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getType = (asLabel = false) => {
      return asLabel ? ProductReview.typesTitle[this.model.type || 'unknown'] || ProductReview.typesTitle['unknown'] : this.model.type;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getText = () => {
      return this.model.text;
    };

    this.getAdvantages = () => {
      return this.model.advantages;
    };

    this.getDisadvantages = () => {
      return this.model.disadvantages;
    };

    this.getVote = () => {
      return this.model.vote;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };

    this.getProduct = product => {
      return this.getRelation('product', Product, product);
    };

    this.getAttachments = attachments => {
      return this.getRelation('attachments', ProductReviewAttachment, attachments, true);
    };
  }

  /**
   * Create product review
   *
   * @param {object} object
   *
   * @return {ProductReview}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list product reviews
   *
   * @param {object} objects
   *
   * @return {Array.<ProductReview>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map product reviews
   *
   * @param {Array.<object>} objects
   * @param {function(ProductReview): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get review id
   *
   * @return {number}
   */


}
ProductReview.types = reviewTypes;
ProductReview.typesTitle = reviewTypesTitle;